// Language data structure
export const translations = {
  EN: {
    // Header
    appTitle: "MobiDeal\nYour Smartphone Shopping Guide",
    headerSubtitle: "Compare phone prices and plans across all stores and carriers",
    navPlans: "Plans",
    navCalculator: "Calculator",
    navChatbot: "Chatbot",
    navFaq: "FAQ",
    
    // Loading
    loadingPhoneData: "Loading phone data...",
    
    // Search
    searchPhones: "Search phones...",
    searchPlaceholder: "Type to search phone models",
    
    // Filters
    filters: "Filters",
    filtersSubtitle: "Customize your search criteria",
    activeFilters: "Active Filters",
    brands: "Brands",
    phoneModels: "Phone Models",
    carriers: "Carriers",
    stores: "Stores",
    storage: "Storage",
    maxMonthlyPrice: "Max Monthly Price",
    maxTotalPrice: "Max Total Price",
    maxPriceAfterGC: "Max Price After GC",
    giftCard: "Gift Card",
    giftCardPromotion: "Gift Card Promotion",
    selectBrandsFirst: "Select brands first",
    any: "Any",
    
    // Results
    noResultsMessage: "No phones match your current filters",
    
    // Table headers
    store: "Store",
    promotions: "Promos",
    total: "Total",
    monthly: "$/MTH",
    down: "Down",
    bringItBack: "Bring It Back",
    priceTrend: "Price Trend",
    actions: "Actions",
    
    // Table content
    giftCardLabel: "Gift Card:",
    totalAfterGC: "Total after GC:",
    premium: "Premium:",
    link: "Link",
    priceHistory: "Price History",
    unavailable: "(N/A)",
    
    // Price History
    priceHistoryTitle: "Price History",
    loadingPriceHistory: "Loading price history...",
    productId: "Product ID:",
    
    // Brands
    apple: "Apple",
    samsung: "Samsung",
    google: "Google",
    motorola: "Motorola",
    others: "Others",

    // Welcome Popup
    welcomeTitle: "Welcome to MobiDeal!",
    welcomeIntro: "This is a platform to compare phones offered with plans across carriers and retailers in Canada.",
    welcomeFeaturesTitle: "What you can do:",
    welcomeFeature1: "Monitor price swings across different retailers and carriers",
    welcomeFeature2: "Track Gift Cards offered with phone plans",
    welcomeFeature3: "Full transparency of the phone cost over the duration of your plan",
    welcomeDonationsTitle: "Support a Good Cause",
    welcomeDonationsText: "If you appreciate using this website, please consider making a donation to one of these important causes:",
    welcomeDonation1: "Alzheimer Society of Canada",
    welcomeDonation2: "Pancreatic Cancer Action Network",
    welcomeLinkedInTitle: "Hiring or Networking?",
    welcomeLinkedInText: "If you work in IT or are a hiring manager, feel free to connect with me on LinkedIn:",
    welcomeAdBlockTitle: "Support This Website",
    welcomeAdBlockText: "Disabling your ad blocker is appreciated to help cover hosting costs and keep this service free for everyone.",
    welcomeButtonClose: "Get Started",

    // Placeholder Pages
    plansTitle: "Plans Comparison",
    plansDescription: "Compare phone plans across all carriers in Canada. Find the best data, call, and text packages for your needs.",
    chatbotTitle: "AI Shopping Assistant",
    chatbotDescription: "Chat with our AI assistant to find the perfect phone and plan based on your needs, budget, and preferences.",
    comingSoon: "Coming Soon",
    inDevelopment: "This feature is currently in development. Check back soon!",
    plansFeature1: "Side-by-side plan comparison",
    plansFeature2: "Filter by data, price, and features",
    plansFeature3: "Historical plan pricing",
    plansFeature4: "Best value recommendations",
    chatbotFeature1: "Personalized phone recommendations",
    chatbotFeature2: "Budget-based suggestions",
    chatbotFeature3: "Compare multiple options",
    chatbotFeature4: "Real-time pricing updates",

    // FAQ Page
    faqTitle: "Frequently Asked Questions",
    faqSubtitle: "Find answers to common questions about MobiDeal",
    stillHaveQuestions: "Still have questions?",
    contactUs: "Contact us at",
    faq1Q: "How often are prices updated?",
    faq1A: "Prices are updated daily from all major Canadian retailers and carriers.",
    faq2Q: "Are the prices accurate?",
    faq2A: "We scrape data directly from retailer websites. While we strive for accuracy, please verify final pricing at the store before purchase.",
    faq3Q: "What does 'Bring It Back' mean?",
    faq3A: "Bring It Back is a program where you return your device after the contract period for a reduced total cost. The premium shown is what you pay over the contract term.",
    faq4Q: "Why do some stores show N/A?",
    faq4A: "N/A means the phone is currently unavailable or out of stock at that retailer for the selected carrier and storage combination.",
    faq5Q: "How do gift cards work?",
    faq5A: "Gift cards are promotional credits offered by retailers. The 'Price After GC' reflects the effective price after applying the gift card value.",
    faq6Q: "Can I filter by carrier?",
    faq6A: "Yes! Use the filters panel on the left (or tap the filters button on mobile) to select specific carriers, stores, storage sizes, and more.",
    faq7Q: "What carriers do you track?",
    faq7A: "We track all major Canadian carriers: Bell, Rogers, Telus, Virgin Plus, Fido, Koodo, and Freedom Mobile.",
    faq8Q: "Is MobiDeal free?",
    faq8A: "Yes, MobiDeal is completely free and always will be. This started a personal project to help Canadians find the best phone deals.",
    faq9Q: "How does the Plans comparison feature work?",
    faq9A: "The Plans page allows you to compare phone plans from all major carriers side-by-side, filtering by data, price, and plan type (BYOD vs With Device). You can easily see which carrier offers the best value for your needs. Note that plan pricing is currently in beta and should be verified directly with carriers.",
    faq10Q: "How does the Calculator feature work?",
    faq10A: "The Calculator helps you understand the true cost of a phone plan by accounting for device financing, plan differences between BYOD and device-eligible plans, gift cards, promotions, and other factors. It shows you whether you're getting a good deal compared to buying a device outright with a BYOD plan.",
    faq11Q: "I have a feature request",
    faq11A: "You're welcome to give me suggestions! Please forward them to admin@mobideal.ca",
    faq12Q: "I love your project! Let's connect on LinkedIn",
    faq12A: "I would love connecting with you all! I'm a new grad computer science graduate trying to connect with people in the industry. Feel free to add me at https://www.linkedin.com/in/simo-hakim/",
    faq13Q: "My favorite carrier is missing",
    faq13A: "We're expanding the carriers displayed soon, but for now we only focus on those offering phones through the major retailers (Best Buy, Costco, Walmart).",

    // FAQ Additional
    trademarks: "Apple, Google, Samsung, Motorola, Best Buy, Costco, Walmart, Bell, Virgin Plus, Koodo, Telus, Rogers, Fido, and Freedom Mobile are registered trademarks of their respective owners. MobiDeal is not affiliated with or endorsed by any of these companies.",

    // Calculator Page
    calculatorTitle: "Plan & Device Calculator",
    calculatorSubtitle: "Calculate the true cost of your phone plan and device",
    provinceTerritory: "Province/Territory",
    detectingLocation: "Detecting location...",
    currentPlanOptional: "Current Plan (Optional)",
    currentPlanHelper: "Enter how much you're currently paying per month on your current bill, including your phone monthly payment if applicable.",
    beforeTax: "Before Tax ($/month)",
    afterTax: "After Tax ($/month)",
    devicePlanDetails: "Device & Plan Details",
    devicePrice: "Price of the device ($/month)",
    devicePriceTooltip: "The monthly cost of the device financing over 24 months",
    devicePlanPrice: "Price of the plan associated with device purchase ($/month)",
    devicePlanPriceTooltip: "The monthly cost of the phone plan that allows device financing (before taxes)",
    byodPlanPrice: "Price of a comparable Bring Your Own Device plan ($/month)",
    byodPlanPriceTooltip: "The monthly cost of a similar Bring Your Own Device plan (no device financing)",
    msrpDevice: "MSRP of the device ($)",
    msrpDeviceTooltip: "The manufacturer's suggested retail price of the device (optional - used to calculate savings)",
    additionalDiscountsCharges: "Additional Discounts & Charges",
    monthlyPlanDiscount: "Monthly Plan Discount ($/month)",
    monthlyPlanDiscountTooltip: "Recurring monthly discounts applied to your plan, such as multi-line discounts, employee discounts, or family plan savings (e.g., -$5/month per extra line)",
    bringItBackPremium: "Bring-It-Back Premium ($)",
    bringItBackPremiumTooltip: "The amount you'll need to pay at the end of 24 months if you want to keep the phone (only applies to Bring-It-Back plans)",
    giftCardPromoValue: "Gift card / promotion value ($)",
    giftCardPromoValueTooltip: "Any gift card or bill credit promotion offered with the device purchase",
    additionalDiscount: "Additional Discount ($)",
    additionalDiscountTooltip: "One-time credits applied to your device purchase, such as Loyalty Agreement Credits, Winback offers, or special promotional discounts",
    calculateDeal: "Calculate Deal",
    costAnalysis: "Cost Analysis",
    requiredFieldsAlert: "Please fill in all required fields (phone price, device plan, BYOD plan)",
    realDeviceCostExplanation: "While the device financing is listed at {phonePrice}/month, the real device monthly cost is actually {realDeviceCost}/month. This is because the device-eligible plan costs {planDifference}/month {planDifferenceDir} than a comparable BYOD plan{additionalDiscountText}.",
    additionalDiscountMoreText: ", but you also have a {discountAmount} additional discount that reduces the cost by {discountMonthly}/month",
    totalDeviceCostOver24: "Over 24 months, you'll pay {phoneUpfrontCost} in device financing{planDifferenceText}{bringItBackText}, bringing your real device cost to {realCost}{giftCardText}{additionalDiscountText}.",
    planDifferenceExtra: " plus {amount} in additional plan costs",
    planDifferenceReduced: " plus {amount} in reduced plan costs",
    bringItBackExtra: " plus a {amount} Bring-It-Back Premium you'll need to pay to keep the device at the end of the contract",
    giftCardText: ". However, you're receiving a {amount} gift card/promotion (worth {preTaxAmount} pre-tax)",
    additionalDiscountExtra: " and a {amount} additional discount",
    effectiveDeviceCost: ", making your effective device cost {cost}",
    monthlyPlanDiscountInfo: "With your {discount}/month plan discount applied, your effective plan cost is {effectiveCost}/month, saving you {savings} over 24 months on your plan.",
    totalCommitment: "Your total commitment over 2 years: {planCost} for the plan and {deviceCost} for device financing, totaling {total}.",
    currentPlanComparison: "Since your current plan costs {currentPlanCost}/month, you'll be paying {difference} {direction} per month.",
    msrpComparison: "Compared to the device MSRP of {msrp}, you're {action} {amount} {actionDetail}{planSpendingText}.",
    msrpComparison2: "{action} {amount} {actionDetail}{planSpendingText}",
    saving: "saving",
    paying: "paying more than retail",
    onTheDevice: "on the device",
    whileSpendingExtra: " while spending an extra {amount} on your plan over 2 years",
    excellentDeal: "This is an excellent deal!",
    excellentDealSubtext: "You're saving {percent}% off the MSRP - exceptional value!",
    goodDeal: "This is a good deal!",
    goodDealSubtext: "You're saving {percent}% off the MSRP",
    fairDeal: "This is a fair deal",
    fairDealSubtext: "You're saving {percent}% off the MSRP - decent but not exceptional",
    badDeal: "This might not be the best deal",
    badDealSubtext: "Consider comparing with other offers or buying the device outright",
    costBreakdown: "Cost Breakdown",
    deviceFinancing: "Device financing (24 months)",
    extraPlanCost: "Extra plan cost (24 months)",
    reducedPlanCost: "Reduced plan cost (24 months)",
    giftCardPromo: "Gift card / promotion",
    bringItBackPremiumLabel: "Bring-It-Back Premium",
    monthlyPlanDiscountLabel: "Monthly Plan Discount (24 months)",
    effectiveDeviceCostLabel: "Effective device cost",
    deviceMSRP: "Device MSRP",
    totalSavings: "Total Savings",
    totalLoss: "Total Loss",
    calculatorNote: "Note",
    calculatorNoteFirstLine: "This calculator assumes a **24-month contract**. All calculations are based on the selected province's/territory **tax rate of {taxRate}%**.",
    calculatorNoteSecondLine: "This calculator is just providing an **estimation**; the calculations aren't standardized across carriers, so your **actual costs may vary**.",
    mandatoryField: "Mandatory field",
    optionalFieldPlaceholder: "Optional field",
    fieldsLegend: "Fields marked with * are required. Fields with a blue tint are optional.",

    // Summary paragraphs
    more: "more",
    less: "less",
    additionalPlanCosts: "additional plan costs",
    reducedPlanCosts: "reduced plan costs",
    monthSuffix: "/month",
    over24Months: "Over 24 months",
    consideringInitialDevicePrice: "considering the initial",
    devicePrice2: "device price",
    yourText: "your",
    additionalDiscountText: "additional discount",
    giftCardPromotionText: "gift card/promotion",
    andThe: "and the",
    bringItBackPremiumText: "Bring-It-Back Premium you'll need to pay to keep the device at the end of the contract",
    plusThe: ", plus the",
    inText: "in",
    yourRealDeviceCostIs: ", your real device cost is",
    withYourText: "With your",
    planDiscountApplied: "plan discount applied",
    yourEffectivePlanCostIs: "your effective plan cost is",
    savingYou: "saving you",
    over24MonthsOnYourPlan: "over 24 months on your plan",
    yourTotalCommitmentOver2Years: "Your total commitment over 2 years:",
    forThePlan: "for the plan",
    andText: "and",
    forDeviceFinancing: "for device financing",
    totaling: "totaling",
    youllBePaying: "You'll be paying",
    perMonthWithThisNewPlanAndDevice: "per month with this new plan and device, and since your current plan costs",
    thatsAnEstimated: ", that's an estimated",
    savingOf: "saving",
    additionalCostOf: "additional cost",
    ofText: "of",
    comparedToTheDeviceMSRPOf: "Compared to the device MSRP of",
    withARealDeviceCostOf: ", with a real device cost of",
    includingAllPromotions: "(including all promotions, gifts and charges and difference compared to a BYOD plan)",
    youre: "you're",
    savingText: "saving",
    payingText: "paying",
    onTheDeviceText: "on the device",
    butItsAkinToPaying: ", but it's akin to paying",
    whileDeviceFinancingIsListedAt: "While the device financing is listed at",
    consideringThatTheDeviceEligiblePlanCosts: ", considering that the device-eligible plan costs",
    thanAComparableBYODPlan: "than a comparable BYOD plan",
    butThatYouAlsoHaveA: ", but that you also have a",
    thatEffectivelyReducesTheCostBy: "that effectively reduces the cost by",
    theDeviceMonthlyCostIs: ", the device monthly cost is",
    additionalDiscountLabel: "Additional Discount",

    // Plans page warnings
    lowDataWarning: "Might not be eligible for High End devices",
    priceConflictWarning: "Price to be verified with the carrier\nConflicting sources exist",
    highEndDevicesPlans: "High-end devices plans",

    // Plans page disclaimer
    plansDisclaimerTitle: "Important Notice",
    plansDisclaimerBeta: "Plan pricing is currently a **beta feature**.",
    plansDisclaimerLimitations: "Due to the nature of our data sources, we cannot guarantee complete pricing accuracy. Please note:",
    plansDisclaimerPoint1: "In-store exclusive offers and pricing may differ",
    plansDisclaimerPoint2: "Special promotional offers (e.g., winback offers, loyalty pricing) are not displayed",
    plansDisclaimerPoint3: "Some plans may have device restrictions for high-end smartphones",
    plansDisclaimerVerify: "Always verify final pricing and eligibility directly with your carrier before making a purchase decision."
  },
  FR: {
    // Header
    appTitle: "MobiDeal\nTrouvez le meilleur Deal !",
    headerSubtitle: "Comparez les prix de smartphones et forfaits à travers détaillants et opérateurs",
    navPlans: "Forfaits",
    navCalculator: "Calculatrice",
    navChatbot: "Chatbot",
    navFaq: "FAQ",
    
    // Loading
    loadingPhoneData: "Chargement des données de téléphones...",
    
    // Search
    searchPhones: "Rechercher des téléphones...",
    searchPlaceholder: "Tapez pour rechercher des modèles",
    
    // Filters
    filters: "Filtres",
    filtersSubtitle: "Personnalisez vos critères de recherche",
    activeFilters: "Filtres Actifs",
    brands: "Marques",
    phoneModels: "Modèles",
    carriers: "Opérateurs",
    stores: "Distributeurs",
    storage: "Stockage",
    maxMonthlyPrice: "Prix Mensuel Max",
    maxTotalPrice: "Prix Total Max",
    maxPriceAfterGC: "Prix Max Après CC",
    giftCard: "Carte-Cadeau",
    giftCardPromotion: "Promotion Carte-Cadeau",
    selectBrandsFirst: "Sélectionnez d'abord les marques",
    any: "Tous",
    
    // Results
    noResultsMessage: "Aucun téléphone ne correspond à vos filtres actuels",
    
    // Table headers
    store: "Magasin",
    promotions: "Promos",
    total: "Total",
    monthly: "$/MOIS",
    down: "Acompte",
    bringItBack: "Option Rapporte-le",
    priceTrend: "Tendance Prix",
    actions: "Actions",
    
    // Table content
    giftCardLabel: "Carte-Cadeau:",
    totalAfterGC: "Total après CC:",
    premium: "Premium:",
    link: "Lien",
    priceHistory: "Historique",
    unavailable: "(N/D)",
    
    // Price History
    priceHistoryTitle: "Historique des Prix",
    loadingPriceHistory: "Chargement de l'historique des prix...",
    productId: "ID Produit:",
    
    // Brands
    apple: "Apple",
    samsung: "Samsung",
    google: "Google",
    motorola: "Motorola",
    others: "Autres",

    // Welcome Popup
    welcomeTitle: "Bienvenue sur MobiDeal !",
    welcomeIntro: "Cette plateforme vous permet de comparer les téléphones offerts avec des forfaits chez les opérateurs et détaillants au Canada.",
    welcomeFeaturesTitle: "Ce que vous pouvez faire :",
    welcomeFeature1: "Surveiller les fluctuations de prix chez différents détaillants et opérateurs",
    welcomeFeature2: "Suivre les Cartes Cadeaux offertes avec les forfaits",
    welcomeFeature3: "Transparence complète du coût du téléphone sur la durée de votre forfait",
    welcomeDonationsTitle: "Soutenez une Bonne Cause",
    welcomeDonationsText: "Si vous appréciez l'utilisation de ce site web, veuillez considérer faire un don à l'une de ces causes importantes :",
    welcomeDonation1: "Société Alzheimer du Canada",
    welcomeDonation2: "Réseau d'action contre le cancer du pancréas",
    welcomeLinkedInTitle: "Recrutement ou Réseautage ?",
    welcomeLinkedInText: "Si vous travaillez en TI ou êtes responsable du recrutement, n'hésitez pas à me connecter sur LinkedIn :",
    welcomeAdBlockTitle: "Supportez Ce Site Web",
    welcomeAdBlockText: "Désactiver votre bloqueur de publicités est apprécié pour aider à couvrir les frais d'hébergement et garder ce service gratuit pour tous.",
    welcomeButtonClose: "Commencer",

    // Placeholder Pages
    plansTitle: "Comparaison de Forfaits",
    plansDescription: "Comparez les forfaits téléphoniques de tous les opérateurs au Canada. Trouvez les meilleurs forfaits de données, d'appels et de textos pour vos besoins.",
    chatbotTitle: "Assistant d'Achat IA",
    chatbotDescription: "Discutez avec notre assistant IA pour trouver le téléphone et le forfait parfaits selon vos besoins, budget et préférences.",
    comingSoon: "Bientôt Disponible",
    inDevelopment: "Cette fonctionnalité est actuellement en développement. Revenez bientôt!",
    plansFeature1: "Comparaison côte à côte des forfaits",
    plansFeature2: "Filtrer par données, prix et fonctionnalités",
    plansFeature3: "Historique des prix des forfaits",
    plansFeature4: "Recommandations de meilleure valeur",
    chatbotFeature1: "Recommandations personnalisées de téléphones",
    chatbotFeature2: "Suggestions basées sur le budget",
    chatbotFeature3: "Comparer plusieurs options",
    chatbotFeature4: "Mises à jour de prix en temps réel",

    // FAQ Page
    faqTitle: "Foire Aux Questions",
    faqSubtitle: "Trouvez des réponses aux questions courantes sur MobiDeal",
    stillHaveQuestions: "Vous avez encore des questions?",
    contactUs: "Contactez-nous à",
    faq1Q: "À quelle fréquence les prix sont-ils mis à jour?",
    faq1A: "Les prix sont mis à jour quotidiennement depuis tous les principaux détaillants et opérateurs canadiens.",
    faq2Q: "Les prix sont-ils exacts?",
    faq2A: "Nous collectons les données directement depuis les sites web des détaillants. Bien que nous visions l'exactitude, veuillez vérifier le prix final au magasin avant l'achat.",
    faq3Q: "Que signifie 'Rapporte-le'?",
    faq3A: "Rapporte-le est un programme où vous retournez votre appareil après la période du contrat pour un coût total réduit. Le premium affiché est ce que vous payez pendant la durée du contrat.",
    faq4Q: "Pourquoi certains magasins affichent N/D?",
    faq4A: "N/D signifie que le téléphone est actuellement indisponible ou en rupture de stock chez ce détaillant pour la combinaison opérateur et stockage sélectionnée.",
    faq5Q: "Comment fonctionnent les cartes-cadeaux?",
    faq5A: "Les cartes-cadeaux sont des crédits promotionnels offerts par les détaillants. Le 'Prix Après CC' reflète le prix effectif après application de la valeur de la carte-cadeau.",
    faq6Q: "Puis-je filtrer par opérateur?",
    faq6A: "Oui! Utilisez le panneau de filtres à gauche (ou appuyez sur le bouton filtres sur mobile) pour sélectionner des opérateurs, magasins, capacités de stockage spécifiques, et plus encore.",
    faq7Q: "Quels opérateurs suivez-vous?",
    faq7A: "Nous suivons tous les principaux opérateurs canadiens: Bell, Rogers, Telus, Virgin Plus, Fido, Koodo, et Freedom Mobile.",
    faq8Q: "MobiDeal est-il gratuit?",
    faq8A: "Oui, MobiDeal est complètement gratuit et le sera toujours. Le site a commencé comme projet personnel avec l'ambition d'aider les Canadiens à trouver les meilleurs promotions pour leurs téléphones.",
    faq9Q: "Comment fonctionne la fonctionnalité de comparaison de forfaits?",
    faq9A: "La page Forfaits vous permet de comparer les forfaits téléphoniques de tous les principaux opérateurs côte à côte, en filtrant par données, prix et type de forfait (BYOD vs Avec Appareil). Vous pouvez facilement voir quel opérateur offre la meilleure valeur pour vos besoins. Notez que la tarification des forfaits est actuellement en version bêta et doit être vérifiée directement auprès des opérateurs.",
    faq10Q: "Comment fonctionne la fonctionnalité de calculatrice?",
    faq10A: "La Calculatrice vous aide à comprendre le coût réel d'un forfait téléphonique en tenant compte du financement d'appareil, des différences de forfait entre BYOD et forfaits compatibles avec appareil, des cartes-cadeaux, promotions et autres facteurs. Elle vous montre si vous obtenez une bonne affaire comparé à l'achat d'un appareil directement avec un forfait BYOD.",
    faq11Q: "J'ai une suggestion de fonctionnalité",
    faq11A: "Vous êtes les bienvenus de me faire des suggestions! Veuillez les transmettre à admin@mobideal.ca",
    faq12Q: "J'adore votre projet! Connectons-nous sur LinkedIn",
    faq12A: "J'adorerais me connecter avec vous tous! Je suis un diplômé récent en informatique qui essaie de se connecter avec les gens de l'industrie. N'hésitez pas à m'ajouter sur https://www.linkedin.com/in/simo-hakim/",
    faq13Q: "Mon opérateur préféré est manquant",
    faq13A: "Nous élargissons bientôt les opérateurs affichés, mais pour l'instant nous nous concentrons uniquement sur ceux qui offrent des téléphones via les grandes chaînes de magasins (Best Buy, Costco, Walmart).",

    // FAQ Additional
    trademarks: "Apple, Google, Samsung, Motorola, Best Buy, Costco, Walmart, Bell, Virgin Plus, Koodo, Telus, Rogers, Fido et Freedom Mobile sont des marques déposées de leurs propriétaires respectifs. MobiDeal n'est pas affilié à ou endorsé par aucune de ces compagnies.",

    // Calculator Page
    calculatorTitle: "Calculatrice de Forfait et d'Appareil",
    calculatorSubtitle: "Calculez le vrai coût de votre forfait téléphonique et appareil",
    provinceTerritory: "Province/Territoire",
    detectingLocation: "Détection de localisation en cours...",
    currentPlanOptional: "Forfait Actuel (Optionnel)",
    currentPlanHelper: "Entrez combien vous payez actuellement par mois sur votre facture actuelle, y compris votre paiement mensuel du téléphone le cas échéant.",
    beforeTax: "Avant Taxes ($/mois)",
    afterTax: "Après Taxes ($/mois)",
    devicePlanDetails: "Détails de l'Appareil et du Forfait",
    devicePrice: "Prix de l'appareil ($/mois)",
    devicePriceTooltip: "Le coût mensuel du financement de l'appareil sur 24 mois",
    devicePlanPrice: "Prix du forfait associé à l'achat d'un appareil ($/mois)",
    devicePlanPriceTooltip: "Le coût mensuel du forfait téléphonique qui permet le financement de l'appareil (avant taxes)",
    byodPlanPrice: "Prix d'un forfait comparable Apportez Votre Propre Appareil ($/mois)",
    byodPlanPriceTooltip: "Le coût mensuel d'un forfait similaire Apportez Votre Propre Appareil (pas de financement d'appareil)",
    msrpDevice: "PDSF de l'appareil ($)",
    msrpDeviceTooltip: "Le prix de détail suggéré par le fabricant de l'appareil (optionnel - utilisé pour calculer les économies)",
    additionalDiscountsCharges: "Rabais et Frais Supplémentaires",
    monthlyPlanDiscount: "Rabais Mensuel du Forfait ($/mois)",
    monthlyPlanDiscountTooltip: "Rabais mensuels récurrents appliqués à votre forfait, tels que rabais multi-lignes, rabais d'employés ou économies sur forfait familial (p. ex., -5 $/mois par ligne supplémentaire)",
    bringItBackPremium: "Prime Rapporte-le ($)",
    bringItBackPremiumTooltip: "Le montant que vous devrez payer à la fin de 24 mois si vous voulez garder le téléphone (s'applique uniquement aux forfaits Rapporte-le)",
    giftCardPromoValue: "Valeur de la carte-cadeau / promotion ($)",
    giftCardPromoValueTooltip: "Toute carte-cadeau ou promotion de crédit de facture offerte avec l'achat de l'appareil",
    additionalDiscount: "Rabais Supplémentaire ($)",
    additionalDiscountTooltip: "Crédits ponctuels appliqués à votre achat d'appareil, tels que Crédits d'Accord de Fidélité, Offres de Rétention ou Rabais Promotionnels Spéciaux",
    calculateDeal: "Calculer l'Offre",
    costAnalysis: "Analyse des Coûts",
    requiredFieldsAlert: "Veuillez remplir tous les champs obligatoires (prix de l'appareil, forfait avec appareil, forfait BYOD)",
    realDeviceCostExplanation: "Bien que le financement de l'appareil soit affiché à {phonePrice}/mois, le vrai coût mensuel de l'appareil est en réalité {realDeviceCost}/mois. C'est parce que le forfait compatible avec le financement d'appareil coûte {planDifference}/mois {planDifferenceDir} qu'un forfait BYOD comparable{additionalDiscountText}.",
    additionalDiscountMoreText: ", mais vous avez aussi un rabais supplémentaire de {discountAmount} qui réduit le coût de {discountMonthly}/mois",
    totalDeviceCostOver24: "Sur 24 mois, vous paierez {phoneUpfrontCost} en financement d'appareil{planDifferenceText}{bringItBackText}, portant votre coût réel de l'appareil à {realCost}{giftCardText}{additionalDiscountText}.",
    planDifferenceExtra: " plus {amount} en coûts de forfait supplémentaires",
    planDifferenceReduced: " plus {amount} en coûts de forfait réduits",
    bringItBackExtra: " plus une Prime Rapporte-le de {amount} que vous devrez payer pour garder l'appareil à la fin du contrat",
    giftCardText: ". Cependant, vous recevez une carte-cadeau/promotion de {amount} (valant {preTaxAmount} avant taxes)",
    additionalDiscountExtra: " et un rabais supplémentaire de {amount}",
    effectiveDeviceCost: ", ce qui rend votre coût effectif de l'appareil {cost}",
    monthlyPlanDiscountInfo: "Avec votre rabais de forfait de {discount}/mois appliqué, votre coût de forfait effectif est {effectiveCost}/mois, vous économisant {savings} sur 24 mois sur votre forfait.",
    totalCommitment: "Votre engagement total sur 2 ans : {planCost} pour le forfait et {deviceCost} pour le financement d'appareil, pour un total de {total}.",
    currentPlanComparison: "Puisque votre forfait actuel coûte {currentPlanCost}/mois, vous paierez {difference} {direction} par mois.",
    msrpComparison: "Comparé au PDSF de l'appareil de {msrp}, vous {action} {amount} {actionDetail}{planSpendingText}.",
    msrpComparison2: "{action} {amount} {actionDetail}{planSpendingText}",
    saving: "économisez",
    paying: "payez plus que le détail",
    onTheDevice: "sur l'appareil",
    whileSpendingExtra: " tout en dépensant {amount} supplémentaires sur votre forfait sur 2 ans",
    excellentDeal: "C'est une affaire exceptionnelle !",
    excellentDealSubtext: "Vous économisez {percent}% du PDSF - valeur exceptionnelle !",
    goodDeal: "C'est une bonne affaire !",
    goodDealSubtext: "Vous économisez {percent}% du PDSF",
    fairDeal: "C'est une affaire correcte",
    fairDealSubtext: "Vous économisez {percent}% du PDSF - décent mais pas exceptionnel",
    badDeal: "Ce n'est peut-être pas la meilleure affaire",
    badDealSubtext: "Envisagez de comparer avec d'autres offres ou d'acheter l'appareil directement",
    costBreakdown: "Analyse des Coûts",
    deviceFinancing: "Financement d'appareil (24 mois)",
    extraPlanCost: "Coût de forfait supplémentaire (24 mois)",
    reducedPlanCost: "Coût de forfait réduit (24 mois)",
    giftCardPromo: "Carte-cadeau / promotion",
    bringItBackPremiumLabel: "Prime Rapporte-le",
    monthlyPlanDiscountLabel: "Rabais Mensuel du Forfait (24 mois)",
    effectiveDeviceCostLabel: "Coût effectif de l'appareil",
    deviceMSRP: "PDSF de l'appareil",
    totalSavings: "Économies Totales",
    totalLoss: "Perte Totale",
    calculatorNote: "Remarque",
    calculatorNoteFirstLine: "Cette calculatrice suppose un **contrat de 24 mois**. Tous les calculs sont basés sur le **taux de taxes de la province/territoire sélectionnée soit {taxRate}%**.",
    calculatorNoteSecondLine: "Cette calculatrice fournit seulement une **estimation** ; les calculs ne sont pas standardisés entre les opérateurs, donc **vos coûts réels peuvent varier**.",
    mandatoryField: "Champ obligatoire",
    optionalFieldPlaceholder: "Champ optionnel",
    fieldsLegend: "Les champs marqués avec * sont obligatoires. Les champs avec une teinte bleue sont optionnels.",

    // Summary paragraphs
    more: "plus",
    less: "moins",
    additionalPlanCosts: "coûts de forfait supplémentaires",
    reducedPlanCosts: "coûts de forfait réduits",
    monthSuffix: "/mois",
    over24Months: "Sur 24 mois",
    consideringInitialDevicePrice: "considérant le",
    devicePrice2: "prix de l'appareil initial",
    yourText: "votre",
    additionalDiscountText: "rabais supplémentaire",
    giftCardPromotionText: "carte-cadeau/promotion",
    andThe: "et la",
    bringItBackPremiumText: "Prime Rapporte-le que vous devrez payer pour garder l'appareil à la fin du contrat",
    plusThe: ", plus les",
    inText: "en",
    yourRealDeviceCostIs: ", votre coût réel de l'appareil est",
    withYourText: "Avec votre",
    planDiscountApplied: "rabais de forfait appliqué",
    yourEffectivePlanCostIs: "votre coût de forfait effectif est",
    savingYou: "vous économisant",
    over24MonthsOnYourPlan: "sur 24 mois sur votre forfait",
    yourTotalCommitmentOver2Years: "Votre engagement total sur 2 ans :",
    forThePlan: "pour le forfait",
    andText: "et",
    forDeviceFinancing: "pour le financement d'appareil",
    totaling: "pour un total de",
    youllBePaying: "Vous paierez",
    perMonthWithThisNewPlanAndDevice: "par mois avec ce nouveau forfait et appareil, et puisque votre forfait actuel coûte",
    thatsAnEstimated: ", c'est une",
    savingOf: "économie estimée",
    additionalCostOf: "coût supplémentaire",
    ofText: "de",
    comparedToTheDeviceMSRPOf: "Comparé au PDSF de l'appareil de",
    withARealDeviceCostOf: ", avec un coût réel de l'appareil de",
    includingAllPromotions: "(incluant toutes les promotions, cadeaux et frais et différence par rapport à un forfait BYOD)",
    youre: "vous",
    savingText: "économisez",
    payingText: "payez",
    onTheDeviceText: "sur l'appareil",
    butItsAkinToPaying: ", mais c'est comme payer",
    whileDeviceFinancingIsListedAt: "Bien que le financement de l'appareil soit affiché à",
    consideringThatTheDeviceEligiblePlanCosts: ", considérant que le forfait compatible avec le financement d'appareil coûte",
    thanAComparableBYODPlan: "qu'un forfait BYOD comparable",
    butThatYouAlsoHaveA: ", mais que vous avez aussi un",
    thatEffectivelyReducesTheCostBy: "qui réduit effectivement le coût de",
    theDeviceMonthlyCostIs: ", le coût mensuel de l'appareil est",
    additionalDiscountLabel: "Rabais Supplémentaire",

    // Plans page warnings
    lowDataWarning: "Pourrait ne pas être éligible pour les appareils haut de gamme",
    priceConflictWarning: "Prix à vérifier avec l'opérateur\nSources conflictuelles",
    highEndDevicesPlans: "Forfaits appareils haut de gamme",

    // Plans page disclaimer
    plansDisclaimerTitle: "Avis Important",
    plansDisclaimerBeta: "La tarification des forfaits est actuellement une **fonctionnalité bêta**.",
    plansDisclaimerLimitations: "En raison de la nature de nos sources de données, nous ne pouvons garantir l'exactitude complète des prix. Veuillez noter :",
    plansDisclaimerPoint1: "Les offres et prix exclusifs en magasin peuvent différer",
    plansDisclaimerPoint2: "Les offres promotionnelles spéciales (ex. offres de rétention, prix de fidélité) ne sont pas affichées",
    plansDisclaimerPoint3: "Certains forfaits peuvent avoir des restrictions d'appareil pour les smartphones haut de gamme",
    plansDisclaimerVerify: "Vérifiez toujours le prix final et l'éligibilité directement auprès de votre opérateur avant de prendre une décision d'achat."
  }
};